import { proximanova, proximanovabold, proximanovathin } from './proximaNovaFont';

export { proximanova, proximanovabold, proximanovathin };
